import { gql } from '@apollo/client'

export const GET_ACTIVITY = gql`
  query getActivity($courseId: ID!, $enrollmentId: ID!, $id: ID!) {
    activity(courseId: $courseId, enrollmentId: $enrollmentId, id: $id) {
      createdAt
      description
      examQuestionsCount
      examLessonId
      id
      maxAttempts
      maxGrade
      minGrade
      retryCount
      retryPermitted
      retryTime
      showComments
      timeLimit
      title
      type
      updatedAt
      examQuestions(pagination: { limit: 1000, offset: 0 }) {
        comment
        createdAt
        id
        order
        point
        title
        updatedAt
        type
        secondAssertions {
          id
          text
        }
        options {
          correct
          id
          order
          title
        }
        firstAssertions {
          id
          text
        }
      }
      examAnswer {
        approved
        autoCorrected
        correctedAt
        createdAt
        id
        score
        updatedAt
        examQuestionAnswers(pagination: { limit: 1000, offset: 0 }) {
          correct
          examQuestionId
          id
          score
          trueOrFalseOption
          multipleChoiceOption {
            correct
            id
            order
            title
          }
          associativeOptions {
            associativeExamQuestionId
            correct
            examQuestionAnswerId
            id
            firstAssertion {
              id
              text
            }
            secondAssertion {
              id
              text
            }
          }
        }
        files {
          name
          url
        }
      }
    }
  }
`

export const GET_ACTIVITY_EXAM_QUESTIONS = gql`
  query getActivityExamQuestions($activityId: ID!) {
    activity(id: $activityId) {
      examQuestions {
        nodes {
          id
          question
        }
      }
    }
  }
`
